import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useIntl } from "react-intl";
import { useHistory } from 'react-router';
import { Typography, withStyles, Container, Button, Box } from '@material-ui/core';

import { FormTextField, Loading, AlertMessages } from '../../components';
import Branding from '../../components/Header/Branding';

import { getAlternateLogo } from "../../utils";
import { getI18n } from "../../utils/intl";
import { ALERT_ERROR } from "../../constants";
import { getThemes } from '../../reducers/portalConfig';
import { resetPassword } from "../../actions/resetPassword";

import styles from './styles';

const ResetPassword = ({
  classes, logo, resetPasswordData, resetPassword, alternateLogo,
}) => {
  const intl = getI18n(useIntl());
  const history = useHistory();
  const [userName, setUserName] = React.useState(false);
  const [userNameError, setUserNameError] = React.useState('')
  const [notification, setNotification] = React.useState({ status: '', message: '' });

  React.useEffect(() => {
    if (resetPasswordData.data) {
      history.push('/admin/app/check-your-email');
    }
    if (resetPasswordData.error !== null) {
      if (resetPasswordData.error === '') {
        setNotification({ status: ALERT_ERROR, message: intl.getI18nMessage("label.unknown.error") });
        return;
      }

      if (resetPasswordData.error?.errorCode) {
        setNotification({
          status: ALERT_ERROR,
          message: intl.getI18nMessage("label.error.code",
            { code: resetPasswordData.error.errorCode }),
        });
        return;
      }

      setNotification({ status: ALERT_ERROR, message: resetPasswordData.error });
    }
  }, [resetPasswordData.data, resetPasswordData.error]);

  const handleChange = (value) => {
    setUserNameError(value ? '' : intl.getI18nMessage("error.field.mandatory"));
    setUserName(value);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userName) {
      resetPassword({ userName });
    } else {
      setUserNameError(intl.getI18nMessage("error.field.mandatory"));
    }
  }

  const showLoadingOverlay = resetPasswordData.isLoading;

  return <Container className={classes.outerContainer}>
    {showLoadingOverlay && <Loading pageLoader fullPage />}
    <Box className={classes.contentContainer}>
      <Box className={classes.header}>
        {logo ? <Branding logo={logo} /> : <Typography variant='h1' className={classes.alternateLogo}>
          {alternateLogo}
        </Typography>}
        <Typography data-apim-test='resetPassword-header' variant='h1' className={classes.headerText}>
          {intl.getI18nMessage("label.custom.pages.select.reset.password")}
        </Typography>
      </Box>
      <form onSubmit={(e) => handleSubmit(e)}>
        <FormTextField
          id='resetPassword-userName'
          name={intl.getI18nMessage("label.username")}
          textFieldClass={classes.textField}
          fieldContainerClass={classes.fieldContainer}
          helperText={userNameError.length > 0 ? userNameError : intl.getI18nMessage("label.user.reset.password.username.helptext")}
          errorHelperText={userNameError.length > 0}
          error={userNameError.length > 0}
          value={userName}
          handleChange={handleChange}
        />

        <Button
          data-apim-test="resetPassword-submit" variant="contained"
          color="secondary" type='submit' className={classes.submitButton}
        >
          {intl.getI18nMessage("label.custom.pages.select.reset.password")}
        </Button>
      </form>
    </Box>
    {notification.message && (
      <AlertMessages
        className={classes.notification}
        id="notificationId"
        data-apim-test="notificationId"
        variant={notification.status}
        message={notification.message}
        onClose={() => setNotification({ status: "", message: "" })}
      />
    )}
  </Container>
}

const mapStateToProps = (state) => {
  const { logo, siteTitle } = getThemes(state);
  return {
    resetPasswordData: state.resetPassword,
    logo,
    alternateLogo: getAlternateLogo(siteTitle),
  };
};

const mapDispatchToProps = {
  resetPassword,
};

ResetPassword.propTypes = {
  classes: PropTypes.object,
  logo: PropTypes.string,
  alternateLogo: PropTypes.string,
  resetPasswordData: PropTypes.object,
  resetPassword: PropTypes.func,
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(ResetPassword);